import * as React from 'react';
import { BookingExistsContent } from '../../../components/BookingExistsContent';
import { FormCardLayout } from '../../../components/RequestFormV2/FormCardLayout';
import { NBSP } from '../../../constants/symbols';
import { useApplicationContext } from '../../../utils/applicationContext';

const image =
  'https://static.cdn-cian.ru/frontend/collections-assets/consulting-request/img-form-desk-booking-exists.png';
const imageMobile =
  'https://static.cdn-cian.ru/frontend/collections-assets/consulting-request/img-form-mob-booking-exists.png';
const defaultLkUrl = 'https://my.cian.ru/buy-newbuilding?openActiveRequest=1';

const DEFAULT_CONTENT_DESCRIPTION = `Если${NBSP}есть${NBSP}вопросы — задайте${NBSP}их${NBSP}консультанту в${NBSP}чате`;

export const RequestFormBookingExists = (): React.JSX.Element => {
  const { config } = useApplicationContext();
  const href = config.get<string>('newbuildingBroker.lkUrl') ?? defaultLkUrl;
  const contentDescription =
    config.get<string>('newbuilding-consultants-frontend.bookingExistsContentDescription') ??
    DEFAULT_CONTENT_DESCRIPTION;

  return (
    <FormCardLayout
      dataTestId="RequestFormBookingExists"
      question="Вы уже отправили заявку"
      image={image}
      imageMobile={imageMobile}
      verticallyCenteredContent
      formGap={8}
      formMobileTextAlign="center"
      wide
    >
      <BookingExistsContent href={href} description={contentDescription} />
    </FormCardLayout>
  );
};
